import React from 'react'
import LaurelsTitle from './LaurelsTitleBrand'
import { useTheme } from '@/components/ThemeProvider'
import TryButtonBrand from './TryButtonBrand'

const HeroBrand = ({ isWhitePage, title }: { isWhitePage?: boolean; title?: string }) => {
  const { theme } = useTheme()
  return (
    <section className="pt-[75px] -mt-[57px] max-w-[430px] z-10 bg-hero w-screen shadow-hero -ml-4 px-6 rounded-b-5xl relative mb-8">
      <LaurelsTitle secondary={theme === 'light'} />
      <div className="flex flex-col  relative z-[1] items-center  pb-6 ">
        <figure className="max-w-full  aspect-[327/264]  mx-auto">
          <img
            src={theme === 'light' ? '/img/hero/hero-image.png' : '/img/hero/1-new.webp'}
            alt="Clean up your camera roll & enjoy the memories with Clean Master!"
            className="w-full z-[1]"
          />
        </figure>
        <h2 className="mb-3 font-bold text-XL text-center">
          {title || 'Clean up your camera roll & enjoy the memories with Clean Master!'}
        </h2>
        <p className="mb-8 text-center text-grayText text-base leading-[1.38]">
          Who Said Cleaning Can’t Be Fun?
        </p>
        <TryButtonBrand to={isWhitePage ? '/new/email' : '/new/scan-results'} />
      </div>
    </section>
  )
}

export default HeroBrand
